import { hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities';
import axios from 'axios';
import moment from 'moment';
import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';
import { connect } from 'react-redux';
import { setAlarm } from '../../../../redux/actions/general';
import { CsvExportFromApiButton, HorizontalSeparator, Spinner } from '../../../common';

import { CardTitle, Col, Row } from 'reactstrap';

import { filtersChanged, timespanOrIntervalChanged } from '../../../../redux/selectors/comparing';

import 'spinkit/css/spinkit.css';

import { PropTypes } from 'prop-types';
import storePropTypes from '../../../../redux/store/propTypes';

import { barChartZoomOptions } from '../../../../constants/chartjs';
import { H5LIVE_VIEW } from '../../../../constants/general';
import {
   CenteredMsgShowing,
   ChartWrapper,
   DescriptionLink,
   HeightSetContainer,
   SetChartHeight,
   SimpleFlexItem,
   SimpleFlexRow,
   StyledButton,
   TwoSideFlexContainer,
   WidgetBodyContainer,
   WidgetContainer,
   WidgetHeaderContainer,
} from '../../../../styledComponents/styledComponents';
import ComponentTools from '../../../../util/ComponentTools';

import { DefaultBlue, DefaultGrey } from '../../../../constants/colors';
import { getUnifiedErrorObject } from '../../../../util/ErrorUnifier';
import { STOP_REASONS } from '../../../zoom/ZoomConstants';
import ZoomHint from '../../../zoom/ZoomHint';
import Modal from '../../../zoom/templates/DefaultTemplate';
import { H5LIVE_SETTINGS } from '../../../zoom/widgetSettings/H5liveView';

const chartOptions = barChartZoomOptions();

const mapStateToProps = (state) => {
   return state.general;
};

const mapDispatchToProps = { setAlarm };

function getNewDataSet(label, color) {
   return {
      total: 0,
      label: label,
      backgroundColor: hexToRgba(color, 10),
      borderColor: color,
      borderWidth: 1,
      data: [],
      hidden: false,
      url: '',
      header: {},
      cancelToken: null,
   };
}

function getTrafficLightColor(status) {
   if (status === 'critical') return '#e83e8c';
   if (status === 'warning') return '#f8cb00';
   if (status === 'expected') return '#20c997';
   return '#6c757d'; // Grey for unknown category
}

let requestForData = false;

class StopReason extends Component {
   constructor(props) {
      super(props);

      this.state = {
         loading: false,
         chart: {
            type: 'bar',
            labels: [],
            datasets: [],
         },
         modal: {
            toggleShow: false,
            timespansPerIndex: [
               {
                  start: moment.utc(),
                  end: moment.utc(),
               },
            ],
            chosenIndex: 0,
            selectedReason: '',
         },
         error: '',
         noData: false,
      };
      this.chartRef = React.createRef();
   }

   getData(timespan, filter, cancelToken) {
      this.setState({
         ...this.state,
         loading: true,
         noData: false,
         error: '',
      });

      const self = this;

      const headerObj = ComponentTools.getHttpHeader(filter);
      const urlFilterQuery = ComponentTools.getFilterQueryParams(filter, H5LIVE_VIEW);

      const updated = {
         type: 'bar',
         labels: [],
         datasets: [],
      };

      const labels = [];
      const timespansPerIndex = [];

      ComponentTools.setBarChartLabels(updated, labels, timespan, this.props.settings.weekType, timespansPerIndex);

      const url = `/v2/h5live/stopReasons/timeseries?from=${timespan.gte.format()}&to=${timespan.lt.format()}&interval=${
         timespan.interval
      }${urlFilterQuery}`;

      axios
         .get(url, {
            headers: headerObj,
            cancelToken: cancelToken.token,
         })
         .then(function (response) {
            // console.log('response:>> ', response);
            let isNoData = false;

            if (response.status !== 204 && response.data?.data) {
               const intervals = response.data.data;

               // Check status from backend response
               isNoData = response.data.statusCode === 2000;

               if (!isNoData) {
                  const sortedReasons = intervals[0].values.slice().sort((a, b) => b.category.code - a.category.code);

                  // Create datasets
                  sortedReasons.forEach(({ key, category }) => {
                     updated.datasets.push(getNewDataSet(key, getTrafficLightColor(category.key)));
                  });

                  // Populate data in datasets
                  updated.datasets.forEach((dataset) => {
                     labels.forEach((label) => {
                        const interval = intervals.find(
                           (inv) => inv.timestamp >= label.start && inv.timestamp < label.end,
                        );

                        const reasonData = interval?.values.find((r) => r.key === dataset.label);

                        const count = reasonData?.count || 0;
                        dataset.data.push(count);
                        dataset.total += count;
                     });
                  });
               }
            }

            self.setState({
               chart: updated,
               noData: isNoData,
               loading: false,
               modal: { ...self.state.modal, timespansPerIndex },
               url,
               header: headerObj,
               cancelToken,
            });
         })
         .catch(function (error) {
            if (error instanceof axios.Cancel) {
               return;
            }
            const errorObject = getUnifiedErrorObject(error);
            self.props.setAlarm('danger', errorObject);

            if (process.env.NODE_ENV === 'development') {
               console.error('error :', error);
            }

            self.setState({
               ...self.state,
               chart: updated,
               error: errorObject.message,
               loading: false,
            });
         });
   }

   componentDidMount() {
      requestForData = true;
   }

   componentWillReceiveProps(nextProps, nextContext) {
      if (timespanOrIntervalChanged(this.props, nextProps) || filtersChanged(this.props, nextProps) || requestForData) {
         requestForData = false;
         this.getData(nextProps.timespan, nextProps.filter, nextProps.cancelToken);

         chartOptions['onClick'] = (event, item) => {
            if (item.length === 0) {
               return;
            }
            const activePoint = this.chartRef.current.chartInstance.getElementAtEvent(event)[0];
            const datasetIndex = activePoint._datasetIndex;
            const data = activePoint._chart.data;
            const clickedLabel = data.datasets[datasetIndex].label;
            const index = item[0]._index;

            this.setState({
               modal: {
                  ...this.state.modal,
                  chosenIndex: index,
                  selectedReason: clickedLabel,
                  toggleShow: true,
               },
            });
         };
      }
   }
   render() {
      const errorOrNoData = this.state.error || this.state.noData;
      const issueMsg = this.state.error ? this.state.error : 'No data available';

      const { toggleShow, selectedReason, timespansPerIndex, chosenIndex } = this.state.modal;
      const chosenTimespan = timespansPerIndex[chosenIndex];
      const { url, header, cancelToken } = this.state;

      return (
         <WidgetContainer>
            <WidgetHeaderContainer>
               <HeightSetContainer $heightInPx={23}>
                  <TwoSideFlexContainer>
                     <SimpleFlexRow>
                        <SimpleFlexItem>
                           <StyledButton
                              type='button'
                              fontSizePx={10.5}
                              className={'btn'}
                              fixMargin
                              name={'csvBtn'}
                              id={'csvBtn'}
                              heightPx={20}
                              widthPx={120}
                              bgColor={DefaultBlue(0.55)}
                              fontColor={'black'}
                              bgColorHover={DefaultBlue(0.4)}
                              fontColorHover={'black'}
                              border={'1px solid rgba(0,0,0,0.2)'}
                              $buttonHeightPx={19}
                           >
                              <DescriptionLink
                                 cursor={'pointer'}
                                 fontSizePX={10.5}
                                 marginLeftPx={0}
                                 href='https://docs.nanocosmos.de/docs/nanoplayer/nanoplayer_api#NanoPlayer..pausereason'
                                 target='_blank'
                                 rel='noopener noreferrer'
                                 $color={'black'}
                              >
                                 View stop reasons
                              </DescriptionLink>
                           </StyledButton>
                        </SimpleFlexItem>
                        <HorizontalSeparator
                           color={DefaultGrey(1, 180)}
                           widthInPx={1}
                           heightInPx={18}
                           marginX_InPx={12}
                           marginTopInPx={0}
                        />
                        <SimpleFlexItem>
                           <CsvExportFromApiButton
                              url={url}
                              header={header}
                              cancelToken={cancelToken}
                              filename={'H5live_StopReason'}
                           />
                        </SimpleFlexItem>
                     </SimpleFlexRow>
                     <SimpleFlexRow>
                        <SimpleFlexItem>
                           <ZoomHint />
                        </SimpleFlexItem>
                     </SimpleFlexRow>
                  </TwoSideFlexContainer>
               </HeightSetContainer>
            </WidgetHeaderContainer>
            <WidgetBodyContainer>
               <Row>
                  <Col>
                     <CardTitle className='mb-0'>Stop reasons</CardTitle>
                     <div className='small text-muted'>
                        {`${this.props.timespan.title}\u00A0\u00A0\u00A0( UTC time )`}
                     </div>
                  </Col>
               </Row>
               <ChartWrapper className='chart-wrapper' marginTopPx={20} height={this.props.height}>
                  <Spinner loading={this.state.loading} parentTopMarginPx={60}>
                     {errorOrNoData ? (
                        <CenteredMsgShowing height={this.props.height}>{issueMsg}</CenteredMsgShowing>
                     ) : (
                        <SetChartHeight height={this.props.height}>
                           <Bar ref={this.chartRef} data={this.state.chart} options={chartOptions} height={300} />
                        </SetChartHeight>
                     )}
                  </Spinner>
               </ChartWrapper>
            </WidgetBodyContainer>
            {toggleShow && (
               <Modal
                  term={selectedReason}
                  timespan={chosenTimespan}
                  metric={STOP_REASONS}
                  closeModal={() =>
                     this.setState({
                        modal: {
                           ...this.state.modal,
                           toggleShow: false,
                        },
                     })
                  }
                  settings={H5LIVE_SETTINGS}
               />
            )}
         </WidgetContainer>
      );
   }
}

StopReason.propTypes = {
   filter: storePropTypes.filter,
   timespan: storePropTypes.timespan,
   cancelToken: storePropTypes.cancelToken,
   settings: storePropTypes.settings,
   setAlarm: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(StopReason);
